import {
  CLIENT_NAME,
  CLIENT_COUNTRY,
  CLIENT_STATE,
  CLIENT_CITY,
  CLIENT_ZIP,
  CLIENT_ADDRESS
} from '@/constants/filters/resources/client'

import {
  SITE_NAME,
  SITE_COUNTRY,
  SITE_CITY,
  SITE_ZIP,
  SITE_ADDRESS,
  SITE_REGION
} from '@/constants/filters/resources/site'

import {
  WORK_ORDER_NUMBER,
  WORK_ORDER_START_DATE,
  WORK_ORDER_CREATED_DATE,
  WORK_ORDER_EXPIRATION_DATE,
  WORK_ORDER_TRIP_EXPIRATION_DATE,
  WORK_ORDER_GENERATION_DATE,
  WORK_ORDER_TYPE,
  WORK_ORDER_PRIORITY,
  WORK_ORDER_TRIP_STATUS,
  WORK_ORDER_STATUS,
  WORK_ORDER_CUSTOM_STATUS,
  WORK_ORDER_CALL,
  WORK_ORDER_JOB_NAME,
  WORK_ORDER_DEPARTMENT_BRANCH,
  WORK_ORDER_FOLLOW_UP_DATE,
  WORK_ORDER_CLIENT_CONTACT,
  WORK_ORDER_TRIP_CATEGORY,
  WORK_ORDER_PROBLEM_TYPE,
  WORK_ORDER_CATEGORY,
  WORK_ORDER_COMPLETION_DATE,
  WORK_ORDER_TRIP_COMPLETION_DATE,
  VENDOR_INVOICE_EXISTS,
  WORK_ORDER_TRADE,
  WORK_ORDER_SERVICE,
  WORK_ORDER_BILLING_METHOD,
  WORK_ORDER_EXTERNAL_REGION,
  WORK_ORDER_SERVICE_CHANNEL_CONNECTION,
  WORK_ORDER_CORRIGO_CONNECTION,
  WORK_ORDER_SERVICE_CHECK_IN_TIME,
  WORK_ORDER_SERVICE_CHECK_OUT_TIME,
  WORK_ORDER_SCHEDULED_SERVICE_NUMBER,
  WORK_ORDER_SCHEDULED_SERVICE
} from '@/constants/filters/resources/workOrder'
import {
  TRIP_CREATION_DATE,
  TRIP_SERVICE_CHECK_IN_TIME,
  TRIP_SERVICE_CHECK_OUT_TIME
} from '../resources/trip'

import {
  PROPOSAL_NUMBER,
  CUSTOM_PROPOSAL_NAME,
  PROPOSAL_STATUS,
  PROPOSAL_DATE_OF_ISSUE,
  PROPOSAL_EXPIRATION_DATE
  // PROPOSAL_CLIENT_NAME,
  // PROPOSAL_SITE_NAME
} from '@/constants/filters/resources/proposal'

import {
  WEATHER_EVENT,
  WEATHER_EVENT_START_DATE,
  WEATHER_EVENT_END_DATE
} from '@/constants/filters/resources/weatherEvent'
import { BROKER, CLIENT } from '@/constants/permissions'
import { useSession } from '@/use/session'
import { CompanyRoleTypes } from '@/types/enums'

export const generateInvoicesFilters = () => {
  const { session } = useSession()

  const availableWeatherEventsFilters = () => {
    const baseFilters: any = []
    if (session.currentCompanyType === BROKER) {
      baseFilters.push(
        WEATHER_EVENT_END_DATE({ pinned: false, isPrimary: false }),
        WEATHER_EVENT_START_DATE({ pinned: true, isPrimary: true }),
        WEATHER_EVENT({ pinned: false, isPrimary: false })
      )
    }
    return baseFilters
  }

  const availableTripFilters = () => {
    const baseFilters: any = [
      TRIP_CREATION_DATE({ pinned: false, isPrimary: false }),
      TRIP_SERVICE_CHECK_IN_TIME({ pinned: false, isPrimary: false }),
      TRIP_SERVICE_CHECK_OUT_TIME({ pinned: false, isPrimary: false })
    ]
    return baseFilters
  }

  const availableWorkOrderFilters = () => {
    const baseFilters: any = [
      WORK_ORDER_NUMBER({ pinned: true, isPrimary: true }, { field: 'wo_id', invoiceables: true }),
      WORK_ORDER_START_DATE({ pinned: false, isPrimary: false }),
      WORK_ORDER_CREATED_DATE({ pinned: false, isPrimary: false }),
      WORK_ORDER_EXPIRATION_DATE({ pinned: false, isPrimary: false }),
      WORK_ORDER_TRIP_EXPIRATION_DATE({ pinned: false, isPrimary: false }),
      WORK_ORDER_GENERATION_DATE({ pinned: false, isPrimary: false }),
      WORK_ORDER_TYPE({ pinned: false, isPrimary: false }, { field: 'work_order_type', invoiceables: true }),
      // WORK_ORDER_PRIORITY({ pinned: false, isPrimary: false }),
      WORK_ORDER_TRIP_STATUS({ pinned: false, isPrimary: false }),
      WORK_ORDER_STATUS({ pinned: false, isPrimary: false }),
      // WORK_ORDER_CALL({ pinned: false, isPrimary: false }),
      WORK_ORDER_JOB_NAME({ pinned: false, isPrimary: false }),
      // WORK_ORDER_DEPARTMENT_BRANCH({ pinned: false, isPrimary: false }),
      WORK_ORDER_FOLLOW_UP_DATE({ pinned: false, isPrimary: false }),
      // WORK_ORDER_CLIENT_CONTACT({ pinned: false, isPrimary: false }),
      // WORK_ORDER_TRIP_CATEGORY({ pinned: false, isPrimary: false }),
      // WORK_ORDER_COMPLETION_DATE(),
      WORK_ORDER_TRIP_COMPLETION_DATE(),
      WORK_ORDER_BILLING_METHOD({ pinned: false, isPrimary: false }),
      WORK_ORDER_CATEGORY({ pinned: false, isPrimary: true }, { field: 'category', invoiceables: true }),
      // WORK_ORDER_PROBLEM_TYPE({ pinned: false, isPrimary: true }, { field: 'problem_type', invoiceables: true })
      WORK_ORDER_SERVICE_CHANNEL_CONNECTION({ pinned: false, isPrimary: false }, { field: 'service_channel_connection_id', invoiceables: true }),
      WORK_ORDER_CORRIGO_CONNECTION({ pinned: false, isPrimary: false }, { field: 'corrigo_connection_id', invoiceables: true }),
      WORK_ORDER_SERVICE_CHECK_IN_TIME({ pinned: false, isPrimary: false }),
      WORK_ORDER_SERVICE_CHECK_OUT_TIME({ pinned: false, isPrimary: false })
    ]
    if (session.currentCompanyType === BROKER) {
      baseFilters.push(
        WORK_ORDER_EXTERNAL_REGION({ pinned: false, isPrimary: false }),
        WORK_ORDER_SERVICE({ pinned: false, isPrimary: false }),
        WORK_ORDER_TRADE({ pinned: false, isPrimary: false }),
        WORK_ORDER_CUSTOM_STATUS({ pinned: false, isPrimary: false }),
        WORK_ORDER_SCHEDULED_SERVICE_NUMBER({ pinned: false, isPrimary: false }),
        WORK_ORDER_SCHEDULED_SERVICE({ pinned: false, isPrimary: false })
      )
    }
    if (session.currentCompanyType === BROKER || session.currentCompanyType === CLIENT) {
      baseFilters.push(
        VENDOR_INVOICE_EXISTS()
      )
    }
    return baseFilters
  }

  const availableSiteFilters = () => {
    const baseFilters: any = [
      SITE_NAME({ pinned: true, isPrimary: true }, { field: 'location', invoiceables: true })
    // SITE_STATE({ pinned: true, isPrimary: true })
    // SITE_COUNTRY({ pinned: false, isPrimary: false }),
    // SITE_CITY({ pinned: false, isPrimary: false }),
    // SITE_ZIP({ pinned: false, isPrimary: false }),
    // SITE_ADDRESS({ pinned: false, isPrimary: false })
    ]
    if (session.currentCompanyType === BROKER) {
      baseFilters.push(
        SITE_REGION({ pinned: false, isPrimary: false })
      )
    }
    return baseFilters
  }

  return {
    filters: [
      CLIENT_NAME({ pinned: true, isPrimary: true }),
      ...availableSiteFilters(),
      ...availableWorkOrderFilters(),
      PROPOSAL_NUMBER(true, { pinned: false, isPrimary: false }, { field: 'proposal_number' }),
      CUSTOM_PROPOSAL_NAME(true, { pinned: false, isPrimary: false }, { field: 'custom_proposal_name' }),
      PROPOSAL_STATUS(CompanyRoleTypes.VENDOR, { pinned: false, isPrimary: false }),
      PROPOSAL_DATE_OF_ISSUE({ pinned: false, isPrimary: false }),
      PROPOSAL_EXPIRATION_DATE({ pinned: false, isPrimary: false }),
      // PROPOSAL_CLIENT_NAME({ pinned: false, isPrimary: false }),
      // PROPOSAL_SITE_NAME({ pinned: false, isPrimary: false })
      ...availableWeatherEventsFilters(),
      // CLIENT_COUNTRY({ pinned: false, isPrimary: false }),
      // CLIENT_STATE({ pinned: false, isPrimary: false }),
      // CLIENT_CITY({ pinned: false, isPrimary: false }),
      // CLIENT_ZIP({ pinned: false, isPrimary: false }),
      // CLIENT_ADDRESS({ pinned: false, isPrimary: false })
      ...availableTripFilters()
    ],
    groupBy: {
      value: 'clients',
      items: [
        {
          label: 'Client and Site',
          value: 'clients'
        },
        {
          label: 'Work Order',
          value: 'work-order'
        }
      ]
    },
    fieldMapping: {
      'client-name': { name: 'work_order_company_name', field: 'text' },
      'client-country': { name: 'work_order_company_headquarter_address_country', field: 'value' },
      'client-state': { name: 'work_order_company_headquarter_address_state', field: 'value' },
      'client-city': { name: 'work_order_company_headquarter_address_city', field: 'value' },
      'client-zip': { name: 'work_order_company_headquarter_address_zip_code', field: 'value' },
      'client-address': { name: 'work_order_company_headquarter_address_formatted_address', field: 'value' },
      'site-name': { name: 'work_order_locations_name', field: 'text' },
      'site-country': { name: 'work_order_locations_address_country', field: 'value' },
      'site-city': { name: 'work_order_locations_address_city', field: 'value' },
      'site-zip': { name: 'work_order_locations_address_zip_code', field: 'value' },
      'site-address': { name: 'work_order_locations_address_full_address', field: 'value' },
      'site-region': { name: 'work_order_locations_cc_territory_name', field: 'text' },
      'site-state': { name: 'work_order_locations_address_state', field: 'value' },
      'work-order-number': { name: 'work_order_id', field: 'text' },
      'work-order-call': { name: 'work_order_call_type', field: 'value' },
      'work-order-expiration-date': { name: 'work_order_expiration_date', field: 'value' },
      'work-order-created-date': { name: 'work_order_created_at', field: 'value' },
      'work-order-priority': { name: 'work_order_priority', field: 'value' },
      'work-order-start-date': { name: 'start_date', field: 'value' },
      'work-order-trip-expiration-date': { name: 'expiration_date', field: 'value' },
      'work-order-generation-date': { name: 'work_order_creation_date', field: 'value' },
      'work-order-type': { name: 'work_order_work_order_type', field: 'value' },
      'work-order-trip-status': { name: 'work_order_extended_status_code', field: 'value' },
      'work-order-status': { name: 'work_order_work_order_status_name', field: 'text' },
      'work-order-custom-status': { name: 'work_order_work_order_status_name', field: 'value' },
      'work-order-job-name': { name: 'work_order_work_order_name', field: 'value' },
      'work-order-department-branch': { name: 'work_order_cu_cc_departments_name', field: 'value' },
      'work-order-follow-up-date': { name: 'work_order_follow_up_at', field: 'value' },
      'work-order-client-contact': { name: 'work_order_client_contacts_full_name', field: 'value' },
      'work-order-trip-category': { name: 'trip_category_name', field: 'value' },
      'work-order-problem-type': { name: 'work_order_problem_type', field: 'value' },
      'work-order-problem-code': { name: 'work_order_category', field: 'value' },
      'work-order-trip-completion-date': { name: 'completed_at', field: 'value' },
      'vendor-invoice-exists': { name: 'vendor_invoice_exists', field: 'value' },
      'work-order-service': { name: 'work_order_trade_services_name', field: 'value' },
      'work-order-trade': { name: 'work_order_trades_name', field: 'value' },
      'work-order-billing-method': { name: 'work_order_work_order_type', field: 'value' },
      'external-region': { name: 'work_order_locations_cc_agreement_external_region', field: 'value' },
      'proposal-number': { name: 'work_order_proposals_estimate_number', field: 'value' },
      'custom-proposal-name': { name: 'work_order_proposals_custom_proposal_name', field: 'value' },
      'proposal-status': { name: 'work_order_proposals_calculated_status_code', field: 'value' },
      'proposal-date-of-issue': { name: 'work_order_proposals_date_of_issue', field: 'value' },
      'proposal-expiration-date': { name: 'work_order_proposals_proposal_date', field: 'value' },
      'proposal-client-name': { name: 'work_order_proposals_company_name', field: 'value' },
      'proposal-site-name': { name: 'work_order_proposals_location_name', field: 'value' },
      'weather-event': { name: 'storm_details_id', field: 'value' },
      'weather-event-start-date': { name: 'storm_details_storms_start', field: 'value' },
      'weather-event-end-date': { name: 'storm_details_storms_end', field: 'value' },
      'corrigo-connection': { name: 'work_order_corrigo_connection_external_id', field: 'value' },
      'service-channel-connection': { name: 'service_channel_connection_external_id', field: 'value' },
      'trip-creation-date': { name: 'start_date', field: 'value' },
      'work-order-service-check-in': { name: 'work_order_services_effective_check_in_time', field: 'value' },
      'work-order-service-check-out': { name: 'work_order_services_effective_check_out_time', field: 'value' },
      'trip-service-check-in': { name: 'services_effective_check_in_time', field: 'value' },
      'trip-service-check-out': { name: 'services_effective_check_out_time', field: 'value' },
      'scheduled-service-agreement-number': { name: 'work_order_agreement_contract_id', field: 'value' },
      'scheduled-service-agreement': { name: 'work_order_contract_id', field: 'value' }
    }
  }
}
